import React from 'react'

interface SecondaryButtonProps {
  children: React.ReactNode
  onClick: () => void
  icon?: React.ReactNode
  size?: 'base' | 'large'
  focused?: boolean
}

const defaultShadow = '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)'
const focusedShadow =
  '0px 0px 0px 4px rgba(59,130,246,0.60), 0px 0px 0px 2px rgba(255,255,255,1.00), 0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)'

const SecondaryButton = ({
  children,
  onClick,
  icon,
  size = 'large',
  focused = false
}: SecondaryButtonProps): JSX.Element => {
  const isBase = size === 'base'
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${
        isBase ? 'px-2.5 py-1.5' : 'px-3 py-2'
      } bg-buttons-button-neutral rounded-md flex justify-center items-center gap-1.5 overflow-hidden`}
      style={{
        boxShadow: focused ? focusedShadow : defaultShadow
      }}>
      {icon}
      <div
        className={`text-buttons-text-secondary font-semibold font-Montserrat leading-5 ${
          isBase ? 'text-xs' : 'text-sm'
        }`}>
        {children}
      </div>
    </button>
  )
}

export default SecondaryButton
